






















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
let digitUppercase = function(n: any) {
	let fraction = ['角', '分']
	let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
	let unit = [
		['元', '万', '亿'],
		['', '拾', '佰', '仟'],
	]
	let head = n < 0 ? '欠' : ''
	n = Math.abs(n)
	let s = ''
	for (let i = 0; i < fraction.length; i++) {
		s += (
			digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]
		).replace(/零./, '')
	}
	s = s || '整'
	n = Math.floor(n)
	for (let i = 0; i < unit[0].length && n > 0; i++) {
		let p = ''
		for (let j = 0; j < unit[1].length && n > 0; j++) {
			p = digit[n % 10] + unit[1][j] + p
			n = Math.floor(n / 10)
		}
		s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
	}
	return (
		head +
		s
			.replace(/(零.)*零元/, '元')
			.replace(/(零.)+/g, '零')
			.replace(/^整$/, '零元整')
	)
}

@Component({})
export default class AgreementSec extends Vue {
	private partyA: any = {}
	private partyB: any = {}
	private date: any = {}
	private address: string = ''
	private signDate: string = ''
	private costMap: any = {}
	private costArr: any = []
	private total: number = 0
	private status: string = ''

	@Prop()
	private agreementsInfo!: any

	@Prop()
	private index!: number

	@Prop()
	private injuredCostArr!: any

	@Prop()
	private isLastHalfMediate!: boolean

	@Watch('agreementsInfo', { immediate: true })
	private onGetAgreements() {
		let {
			partyA,
			partyB,
			date,
			address,
			costArr,
			costMap,
			signDate,
			total,
			status,
		}: {
			partyA: any
			partyB: any
			date: any
			address: string
			costArr: any
			costMap: any
			signDate: string
			total: number
			status: string
		} = this.agreementsInfo[this.index]

		this.partyA = partyA || {}
		this.partyB = partyB || {}
		this.date = date || {}
		this.address = address
		this.costArr = costArr
		this.costMap = costMap
		this.signDate = signDate
		this.total = total as number
		this.status = status as string
	}

	@Watch('injuredCostArr', { immediate: true })
	private onCostMapChange() {
		let {
			costMap,
			costArr,
			total,
		}: { costMap: any; costArr: any; total: number } =
			this.injuredCostArr[this.index] || {}
		if (costMap) {
			this.costMap = costMap
		}
		if (costArr) {
			this.costArr = costArr
			this.total = total
		}
	}

	private digitUppercase(amount: number) {
		return digitUppercase(amount)
	}

	private getURL(url: any) {
		if (url) {
			return url + '?imageMogr2/thumbnail/192x'
		} else {
			return ''
		}
	}
}
